import React from 'react';
import { Grid, Image, Modal } from '@mantine/core';
import styled from '@emotion/styled';
import { Theme } from '@seedlang/constants';
import Button from 'components/button/button';
import SeedlangLogoWithBold from 'components/seedlang_logo_with_bold';

const IMAGE_URLS_BY_LANGUAGE_NAME = {
  French: 'https://dt8fj7um6g334.cloudfront.net/external_media/RackMultipart20260902-70-tgrhht.png',
  German: 'https://dt8fj7um6g334.cloudfront.net/external_media/RackMultipart20260902-108-tgrhht.png',
  Spanish: 'https://dt8fj7um6g334.cloudfront.net/external_media/RackMultipart20260902-108-zp2r5c.png',
};

const TextColumn = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-top: 32px;
  padding-right: 10px;

  p {
    margin: 0 0 16px;
  }
`;

export const SeedlangExplainerModal = ({
  isPodcastEpisode,
  languageName,
  opened,
  onClose,
}) => (
  <Modal
    opened={opened}
    onClose={onClose}
    padding={32}
    radius='xl'
    size='lg'
    title={(
      <div style={{width: 220}}>
        <SeedlangLogoWithBold />
      </div>
    )}
    styles={{
      close: {
        background: 'transparent',
        color: '#FFF',
        marginLeft: 'auto',
        order: 1,
        '&:hover': {
          background: 'rgba(255, 255, 255, 0.15)',
        },
      },
      header: {
        alignItems: 'flex-start',
        background: Theme.blue,
        flexWrap: 'wrap',
      },
      title: {
        marginTop: 8,
        order: 2,
        width: '100%',
      },
    }}
  >
    <Grid>
      <Grid.Col span={{base: 12, sm: 8}}>
        <TextColumn>
          <p>
            To review words from this
            {' '}{isPodcastEpisode ? 'podcast episode' : 'video'}, you can use our partner app
            {' '}<strong>Seedlang</strong> for free!
          </p>
          <p>
            Flashcards on Seedlang have <strong>videos with native speakers</strong>
            {' '}and detailed grammar information.
          </p>
          <p>
            You can use your <strong>Easy {languageName} login</strong> to practice
            {' '}{languageName} in the Seedlang App or in your browser at
            {' '}<a
              href='https://seedlang.com'
              rel='noopener noreferrer'
              style={{
                color: Theme.darkBlue,
                textDecoration: 'underline',
              }}
              target='_blank'
            >
              seedlang.com
            </a>.
          </p>
          <Button
            background={Theme.blue}
            onClick={onClose}
            style={{alignSelf: 'flex-start', marginTop: 'auto'}}
          >
            Got it
          </Button>
        </TextColumn>
      </Grid.Col>
      <Grid.Col
        span={4}
        visibleFrom='sm'
      >
        <Image
          alt='Screenshot from the Seedlang App'
          radius='lg'
          src={
            IMAGE_URLS_BY_LANGUAGE_NAME[languageName] ||
            IMAGE_URLS_BY_LANGUAGE_NAME.German
          }
          style={{
            marginTop: -29,
            position: 'relative',
            zIndex: 1001,
          }}
        />
      </Grid.Col>
    </Grid>
  </Modal>
);

export default SeedlangExplainerModal;
